<div class="flex items-center flex-col">
    <h1 class="mt-10">404</h1>
    <h4 class="text-gray-500">This page was not Found</h4>
</div>
